var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributeSessionDataTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.125C1.00898 1.125 0 2.13398 0 3.375V14.625C0 15.866 1.00898 16.875 2.25 16.875H15.75C16.991 16.875 18 15.866 18 14.625V3.375C18 2.13398 16.991 1.125 15.75 1.125H2.25ZM1.6875 5.0625H16.3125V7.3125H1.6875V5.0625ZM1.6875 9H7.3125V11.25H1.6875V9ZM9 9H16.3125V11.25H9V9ZM1.6875 12.9375H7.3125V15.1875H2.25C1.93934 15.1875 1.6875 14.9357 1.6875 14.625V12.9375ZM9 12.9375H16.3125V14.625C16.3125 14.9357 16.0607 15.1875 15.75 15.1875H9V12.9375Z",
    fill: "#626F86"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeSessionDataTable);
export default __webpack_public_path__ + "static/media/attributeSessionDataTable.fd4da90e13e4cf0821df53c20ebb4934.svg";
export { ForwardRef as ReactComponent };